import { Component } from '@angular/core';

@Component({
  selector: 'uni-table-header',
  templateUrl: './uni-table-header.component.html',
  styleUrls: ['./uni-table-header.component.scss'],
})
export class UniTableHeaderComponent {}
